import React, { Children, Fragment } from 'react';
import { block } from '../../../utils';
import { ViewModeItem } from '../../types';
import ControlPanel from '../ControlPanel/ControlPanel';
import DeviceEmulation from '../DeviceEmulation/DeviceEmulation';
import './Layout.css';
const b = block('editor-layout');
const Left = () => null;
const Right = () => null;
const Layout = ({ children, mode, onModeChange, theme, onThemeChange, }) => {
    let left, right;
    const isEditingMode = mode === ViewModeItem.Edititng;
    function handleChild(child) {
        switch (child === null || child === void 0 ? void 0 : child.type) {
            case Left:
                left = child === null || child === void 0 ? void 0 : child.props.children;
                break;
            case Right:
                right = child === null || child === void 0 ? void 0 : child.props.children;
                break;
        }
    }
    if (React.Children.toArray(children).length) {
        Children.forEach(children, handleChild);
    }
    return (React.createElement("div", { className: b() },
        React.createElement(ControlPanel, { viewMode: mode, onViewModeChange: onModeChange, className: b('panel'), theme: theme, onThemeChange: onThemeChange }),
        React.createElement("div", { className: b('container') },
            React.createElement(Fragment, null,
                left && React.createElement("div", { className: b('left') }, left),
                right && (React.createElement("div", { className: b('right', { editing: isEditingMode }) },
                    React.createElement(DeviceEmulation, { mode: mode }, right)))))));
};
Layout.Left = Left;
Layout.Right = Right;
export default Layout;
